module.exports = __webpack_public_path__ + "fonts/comfortaa-v27-latin-600.d1d86347.woff";